import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DomainAuthenticationModule } from '@symphony-solo/domain/authentication/src';
import { DomainCartModule } from '@symphony-solo/domain/cart/src';
import { DomainOrderModule } from '@symphony-solo/domain/order/src';
import { DomainPursesModule } from '@symphony-solo/domain/purses/src';
import { DomainHistoryModule } from '@symphony-solo/domain/history/src';
import { DomainVoucherModule } from '@symphony-solo/domain/voucher/src';
import { DomainChooseLocationModule } from '@symphony-solo/domain/choose-location/src';
import { DomainAccountSettingsModule } from '@symphony-solo/domain/account-settings/src';
import { DomainScanQROrderModule } from '@symphony-solo/domain/scan-qr-order/src';
import { DomainCompanyGroupModule } from '@symphony-solo/domain/company-group/src';
import { CompanyConfigFacade, DomainCompanyConfigModule } from '@symphony-solo/domain/company-config/src';
import { DomainCustomerGroupsModule } from '@symphony-solo/domain/customer-groups/src';
import { DomainFeatureStatesAggregatorModule } from '@symphony-solo/domain/feature-states-aggregator/src';
import { DomainLocationModule } from '@symphony-solo/domain/location/src';
import { DomainPaymentCardsModule } from '@symphony-solo/domain/payment-cards/src';
import { DomainLoyaltyCardsModule } from '@symphony-solo/domain/loyalty-cards/src';
import { DomainPaymentsModule } from '@symphony-solo/domain/payments/src/lib/domain-payments.module';
import { DomainPurchaseHistoryModule } from '@symphony-solo/domain/purchase-history/src';
import { DomainScannerModule } from '@symphony-solo/domain/scanner/src';
import { DomainFavouriteItemModule } from '@symphony-solo/domain/favourite-item/src';
import { DomainSelectProductModule } from '@symphony-solo/domain/select-product/src';
import { DomainSyncDataModule } from '@symphony-solo/domain/sync-data/src';
import { DomainTermsAndConditionsModule } from '@symphony-solo/domain/terms-and-conditions/src';
import { DomainToastModule } from '@symphony-solo/domain/toast/src';
import { DomainTransactionReceiptModule } from '@symphony-solo/domain/transaction-receipt/src';
import { DomainTransactionModule } from '@symphony-solo/domain/transaction/src';
import { PagesLoyaltyWebsiteModule } from '@symphony-solo/pages/loyalty-website/src';
import { PagesRoutingSharedModule } from '@symphony-solo/pages/routing-shared/src';
import { SharedAlertModule } from '@symphony-solo/shared/alert/src';
import { SharedCommonStateModule } from '@symphony-solo/shared/common-state/src';
import { SharedComponentsModule } from '@symphony-solo/shared/components/src';
import { SharedErrorHandlingModule } from '@symphony-solo/shared/error-handling/src';
import { NetworkConnectivityModule } from '@symphony-solo/shared/network-connectivity/src';
import { SharedToastModule } from '@symphony-solo/shared/toast/src';
import { LoadingSpinnerService, SmartComponentsModule } from '@symphony-solo/smart-components/src';
import { IonicStorageModule } from '@ionic/storage-angular';
// tslint:disable-next-line: nx-enforce-module-boundaries
import { environment } from '../../../../../apps/ionic-green4/src/environments/environment';

@NgModule({
  imports: [
    CommonModule,
    SharedCommonStateModule,
    PagesRoutingSharedModule,
    SharedComponentsModule,
    SharedErrorHandlingModule,
    DomainScannerModule.forRoot({ useMockScanner: environment.useMockScandit }),
    DomainToastModule.forRoot(),
    DomainSyncDataModule.forRoot(),
    PagesLoyaltyWebsiteModule.forRoot(),
    DomainAuthenticationModule.forRoot(),
    DomainCompanyConfigModule.forRoot(),
    DomainCartModule.forRoot(),
    DomainOrderModule.forRoot(),
    DomainPursesModule.forRoot(),
    DomainHistoryModule.forRoot(),
    DomainVoucherModule.forRoot(),
    DomainChooseLocationModule.forRoot(),
    DomainAccountSettingsModule.forRoot(),
    DomainScanQROrderModule.forRoot(),
    DomainFavouriteItemModule.forRoot(),
    DomainCompanyGroupModule.forRoot(),
    DomainTransactionModule.forRoot(),
    DomainFeatureStatesAggregatorModule.forRoot(),
    NetworkConnectivityModule.forRoot(),
    SharedToastModule.forRoot(),
    SharedAlertModule.forRoot(),
    DomainPaymentCardsModule.forRoot(),
    DomainLoyaltyCardsModule.forRoot(),
    SharedErrorHandlingModule.forRoot(),
    DomainCustomerGroupsModule.forRoot(),
    DomainLocationModule.forRoot(),
    SmartComponentsModule.forRoot(),
    DomainPaymentsModule.forRoot(),
    DomainTermsAndConditionsModule.forRoot(),
    DomainTransactionReceiptModule.forRoot(),
    DomainPurchaseHistoryModule.forRoot(),
    DomainSelectProductModule.forRoot(),
    IonicStorageModule.forRoot(),
  ],
  exports: [NetworkConnectivityModule],
})
export class CommonCoreModule {
  public constructor(private loadingSpinnerService: LoadingSpinnerService, private companyConfigFacade: CompanyConfigFacade) {
    this.loadingSpinnerService.startListenToLoading();
    this.companyConfigFacade.getCompanyConfig();
  }
}
